import { clsx } from "clsx";
import { twMerge } from "tailwind-merge";

export function cn(...inputs) {
  return twMerge(clsx(inputs));
}

export function formatDanishDate(dateStr) {
  if (!dateStr) return '';
  const str = String(dateStr).trim();
  if (/[a-zæøå]/i.test(str) && !str.includes('T')) return str;
  const m = str.match(/^(\d{4})-(\d{2})-(\d{2})/);
  if (m) {
    const months = [
      'januar', 'februar', 'marts', 'april', 'maj', 'juni',
      'juli', 'august', 'september', 'oktober', 'november', 'december'
    ];
    const day = parseInt(m[3], 10);
    const month = months[parseInt(m[2], 10) - 1] || '';
    const year = m[1];
    return `${day}. ${month} ${year}`;
  }
  const d = new Date(str);
  if (!isNaN(d.getTime())) {
    const months = [
      'januar', 'februar', 'marts', 'april', 'maj', 'juni',
      'juli', 'august', 'september', 'oktober', 'november', 'december'
    ];
    return `${d.getDate()}. ${months[d.getMonth()]} ${d.getFullYear()}`;
  }
  return str;
}

